import React, { useEffect, useState } from 'react';

import { Selectable } from '@vestahealthcare/common/enums/Enum';
import { translate } from '@vestahealthcare/common/i18n';

import { FilterItem, FilterSelectable, Select, TextInput } from 'styleguide-v2';

import { useDebounce } from 'dash/src/utils/debounceUtils';
import { getFilterItem } from 'dash/src/utils/filterUtils';

import { KeyGetReferralParams } from './types';

type Props = {
  data: {
    statuses: Selectable[];
  };
  filters?: {
    [x in KeyGetReferralParams]?: FilterItem;
  };
  loading?: boolean;
  onChange: (
    filters: {
      [x in KeyGetReferralParams]?: FilterItem;
    },
  ) => void;
};

export const ReferralsFiltersBar = ({
  data,
  filters,
  loading,
  onChange,
}: Props) => {
  const [name, setName] = useState<string>();
  const debouncedName = useDebounce(name, 300);

  useEffect(() => {
    setName((filters?.name?.value as FilterSelectable)?.value as string);
  }, [filters?.name]);

  useEffect(() => {
    if (
      debouncedName !==
      ((filters?.name?.value as FilterSelectable)?.value as string)
    )
      onChange({
        ...filters,
        name: getFilterItem(
          translate('referrals.name'),
          debouncedName?.toLocaleLowerCase()?.trim(),
        ),
      });
  }, [debouncedName]);

  return (
    <>
      <TextInput
        data-cy="referrals-filter-bar-name"
        onChange={setName}
        placeholder={translate('referrals.name')}
        size="xs"
      />
      <Select
        data-cy="employee-filter-bar-status"
        items={data.statuses}
        limitTags={1}
        loading={loading}
        multiple
        onChange={(values: Selectable[]) =>
          onChange({
            ...filters,
            status: getFilterItem(translate('referrals.status'), values),
          })
        }
        placeholder={translate('referrals.status')}
        placeholderV2
        size="xs"
        value={filters?.status?.value || []}
      />
    </>
  );
};
